import { configureStore } from '@reduxjs/toolkit'

import { configReducer } from './configuration'
import { propertiesReducer } from './properties'
import { currenciesReducer } from './currencies'
import { rateDataReducer } from './rateData'
import { calendarAvailabilityReducer } from './calendarAvailability'
import { promoReducer } from './promos'
import { userDataReducer } from './userData'

export const store = configureStore({
  reducer: {
    configuration: configReducer,
    properties: propertiesReducer,
    currencies: currenciesReducer,
    rateData: rateDataReducer,
    calendarData: calendarAvailabilityReducer,
    promos: promoReducer,
    userData: userDataReducer,
  },
})
